import React, { useContext } from 'react';
import { MemberContext } from '../../../../context/member-context';
import EventItem from './event-item';
import Svg from '../../icons/svg';
import Dropdown from '../../dropdown/dropdown';

const EventsList = () => {
  const { events } = useContext(MemberContext);

  return (
    <Dropdown
      toggle={
        <div>
          {parseInt(events.unseenCount) > 0 && (
            <div className="toggle-badge align-items-center justify-content-center">
              <div>{events.unseenCount}</div>
            </div>
          )}
          <Svg name={'activity'} width={24} height={24} fill={'#262626'} label={'Activity'} />
        </div>
      }
      menu={
        <div className="dropdown-body p-0">
          <ul className="list-group">
            {parseInt(events.unseenCount) > 0 && (
              <li className="list-item close-menu c-p" onClick={events.eventsSeen}>
                <span className="item font-weight-bold">همه اعلان های جدید را دیدم</span>
              </li>
            )}
            {events.list.length === 0 && (
              <li className="list-item close-menu">
                <span className="item font-size-3 color-gray">موردی وجود ندارد</span>
              </li>
            )}
            {events.list.map((item, i) => {
              return <EventItem data={item} key={'ei-' + i} />;
            })}
          </ul>
        </div>
      }
      placement={'top-left'}
      className={'activity'}
      bodyScrollDisabled={true}
      closeBtnValue={'بستن لیست'}
    />
  );
};

export default EventsList;
